$(document).ready(function(){

 $(".store_button").click(function(){
    let map = $(this).parent().siblings()[0]
    if ($(map).hasClass("active")) {
      $(map).removeClass('active');
      $(this).parent().removeClass('active');
      $(this).text("SHOW ON MAP");
      return false;
    }
    $(map).addClass('active');
    $(this).parent().addClass('active');
    $(this).text("HIDE MAP");
  });
  
});